/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PartySelect = ({
  data,
  selectedParty,
  partyQueryHandler,
  isDesktop,
  isCommuneSearchActive,
  t,
}) => {
  const [selected, setSelected] = useState(selectedParty);

  useEffect(() => {
    if (
      selected &&
      selectedParty &&
      selected.partyId !== selectedParty.partyId
    ) {
      partyQueryHandler(selected.partyId);
    }
  }, [selected, selectedParty]);

  const logoOrder = [
    "lsap",
    "dp",
    "deigreng",
    "csv",
    "deilenk",
    "adr",
    "piraten",
    "fokus",
    "volt",
    "kpl",
    "libertefraiheet",
    "deikonservativ",
  ];

  data.sort((a, b) => {
    return logoOrder.indexOf(a.logo) - logoOrder.indexOf(b.logo);
  });
  return (
    <div
      className={`${isDesktop ? "ml-4" : "ml-0"}`}
      style={{ maxWidth: "343px" }}
    >
      {isCommuneSearchActive ? (
        <input
          type="text"
          className="cursor-not-allowed w-full h-12 py-2 pl-3 pr-10 text-left text-gray-700 bg-gray-100 bg-clip-padding rounded-md border border-gray-300"
          placeholder={t("back")}
          aria-label={t("back")}
          disabled
        />
      ) : (
        <Listbox value={selected} onChange={setSelected}>
          {({ open }) => (
            <>
              <div className="relative">
                <Listbox.Button className="relative w-full cursor-default h-12 rounded-md border border-gray-300 bg-wort-background py-2 pl-3 pr-10 text-left shadow-sm focus:border-focus-ring focus:outline-none focus:ring-1 focus:ring-focus-ring sm:text-sm">
                  <span className="block truncate font-med">
                    {selected?.partyName}
                  </span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronDownIcon
                      className="h-5 w-5 text-black"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>

                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute z-10 mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                    {data.map((party) => (
                      <Listbox.Option
                        key={party.partyId}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "text-gray-900 bg-F4F4F4"
                              : "text-gray-900",
                            "relative cursor-default select-none py-1 pl-8 pr-4"
                          )
                        }
                        value={party}
                      >
                        {({ selected, active }) => (
                          <>
                            <span
                              className={classNames(
                                selected ? "font-semibold" : "font-normal",
                                "block truncate"
                              )}
                            >
                              {party.partyName}
                            </span>

                            {selected ? (
                              <span
                                className={classNames(
                                  active
                                    ? "text-focus-ring"
                                    : "text-focus-ring",
                                  "absolute inset-y-0 left-0 flex items-center pl-1.5"
                                )}
                              >
                                <CheckIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </span>
                            ) : null}
                          </>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      )}
    </div>
  );
};

export default PartySelect;
